import React from 'react'
import {
  IntlProvider,
  load,
  LocalizationProvider,
  loadMessages,
} from '@progress/kendo-react-intl'
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json'
import currencyData from 'cldr-core/supplemental/currencyData.json'
import weekData from 'cldr-core/supplemental/weekData.json'
import numbers from 'cldr-numbers-full/main/es/numbers.json'
import currencies from 'cldr-numbers-full/main/es/currencies.json'
import caGregorian from 'cldr-dates-full/main/es/ca-gregorian.json'
import dateFields from 'cldr-dates-full/main/es/dateFields.json'
import timeZoneNames from 'cldr-dates-full/main/es/timeZoneNames.json'
import esMessages from '../locales/sp/grid2.json'
import enMessages from '../locales/en/grid2.json'
import frMessages from '../locales/fr/grid2.json'
import i18n from 'i18next'

const language = 'en-EN'
export const formatNumberWithDecimals = value => {
  var valor = value
  valor = valor ? valor : 0
  var result = parseFloat(valor).toLocaleString(language, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  return result !== 'NaN' ? result : 0
}

export const ConcatNameTrack = data => {
  var name = 'Búsqueda por '
  data.filter.filters.map(item => {
    name = name.concat(item.field + ',')
    return 0
  })
  return name
}

export const formatNumberWithDecimals3 = value => {
  var valor = value
  valor = valor ? valor : 0
  var result = parseFloat(valor).toLocaleString(language, {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  })
  return result !== 'NaN' ? result : 0
}

export const deleteInitialAndEndSpace = value => {
  let resultString = value.trim()
  return resultString
}

export const actualizarHora = fecha => {
  if (!fecha) {
    return fecha
  }
  var horaActual = new Date()
  var ano = fecha.getFullYear()
  var mes = fecha.getMonth()
  var dia = fecha.getDate()
  var hora = horaActual.getHours()
  var minuto = horaActual.getMinutes()
  var seg = horaActual.getSeconds()
  var nuevahora = new Date(ano, mes, dia, hora, minuto, seg)
  return nuevahora
}
export const formatNumberWithDecimals4 = value => {
  var valor = value
  valor = valor ? valor : 0
  var result = parseFloat(valor).toLocaleString(language, {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  })
  return result !== 'NaN' ? result : 0
}

export const formatNumber = value => {
  var valor = value
  valor = valor ? valor : 0
  return parseFloat(valor).toLocaleString(language, {
    minimumFractionDigits: 0,
  })
}

export const FormatDecimalGrid = data => {
  if (data.rowType === 'groupFooter') {
    return <td></td>
  } else if (data.rowType === 'groupHeader') {
    return null
  } else {
    var valor = data.dataItem[data.field]
    valor = valor ? valor : 0
    var monto = parseFloat(valor).toLocaleString(language, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
    return <td>{monto}</td>
  }
}

export const FormatDecimalGridWithGreenHighlight = data => {
  if (data.rowType === 'groupHeader') {
    return null
  }
  var valor = data.dataItem[data.field]
  valor = valor ? valor : 0
  var monto = parseFloat(valor).toLocaleString(language, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  return <td className="highlightSubtotalsGreen">{monto}</td>
}

export const IdiomaGrilla = props => {
  var idioma = i18n.language
  if (!idioma) {
    idioma = 'es'
  }
  load(
    likelySubtags,
    currencyData,
    weekData,
    numbers,
    currencies,
    caGregorian,
    dateFields,
    timeZoneNames
  )
  loadMessages(esMessages, 'es')
  loadMessages(enMessages, 'en')
  loadMessages(frMessages, 'fr')
  let style = {}
  if (
    props.children &&
    props.children.type &&
    props.children.type.displayName === 'KendoReactGrid'
  ) {
    style = {
      paddingBottom: 150,
    }
  }

  return (
    <LocalizationProvider language={idioma}>
      <IntlProvider locale="es">
        <div style={style}>{props.children}</div>
      </IntlProvider>
    </LocalizationProvider>
  )
}

export const convertNumberToString = value => {
  const Unidades = num => {
    switch (num) {
      case 1:
        return 'UN'
      case 2:
        return 'DOS'
      case 3:
        return 'TRES'
      case 4:
        return 'CUATRO'
      case 5:
        return 'CINCO'
      case 6:
        return 'SEIS'
      case 7:
        return 'SIETE'
      case 8:
        return 'OCHO'
      case 9:
        return 'NUEVE'
      default:
        return 'UN'
    }
  }
  const Decenas = num => {
    var decena = Math.floor(num / 10)
    var unidad = num - decena * 10

    switch (decena) {
      case 1:
        switch (unidad) {
          case 0:
            return 'DIEZ'
          case 1:
            return 'ONCE'
          case 2:
            return 'DOCE'
          case 3:
            return 'TRECE'
          case 4:
            return 'CATORCE'
          case 5:
            return 'QUINCE'
          default:
            return 'DIECI' + Unidades(unidad)
        }
      case 2:
        switch (unidad) {
          case 0:
            return 'VEINTE'
          default:
            return 'VEINTI' + Unidades(unidad)
        }
      case 3:
        return DecenasY('TREINTA', unidad)
      case 4:
        return DecenasY('CUARENTA', unidad)
      case 5:
        return DecenasY('CINCUENTA', unidad)
      case 6:
        return DecenasY('SESENTA', unidad)
      case 7:
        return DecenasY('SETENTA', unidad)
      case 8:
        return DecenasY('OCHENTA', unidad)
      case 9:
        return DecenasY('NOVENTA', unidad)
      case 0:
        return Unidades(unidad)
      default:
        return Unidades(unidad)
    }
  }
  const DecenasY = (strSin, numUnidades) => {
    if (numUnidades > 0) return strSin + ' Y ' + Unidades(numUnidades)
    return strSin
  }
  const Centenas = num => {
    var centenas = Math.floor(num / 100)
    var decenas = num - centenas * 100

    switch (centenas) {
      case 1:
        if (decenas > 0) return 'CIENTO ' + Decenas(decenas)
        return 'CIEN'
      case 2:
        return 'DOSCIENTOS ' + Decenas(decenas)
      case 3:
        return 'TRESCIENTOS ' + Decenas(decenas)
      case 4:
        return 'CUATROCIENTOS ' + Decenas(decenas)
      case 5:
        return 'QUINIENTOS ' + Decenas(decenas)
      case 6:
        return 'SEISCIENTOS ' + Decenas(decenas)
      case 7:
        return 'SETECIENTOS ' + Decenas(decenas)
      case 8:
        return 'OCHOCIENTOS ' + Decenas(decenas)
      case 9:
        return 'NOVECIENTOS ' + Decenas(decenas)
      default:
        return 'NOVECIENTOS ' + Decenas(decenas)
    }
  }
  const Seccion = (num, divisor, strSingular, strPlural) => {
    var cientos = Math.floor(num / divisor)
    var resto = num - cientos * divisor

    var letras = ''

    if (cientos > 0)
      if (cientos > 1) letras = Centenas(cientos) + ' ' + strPlural
      else letras = strSingular

    if (resto > 0) letras += ''

    return letras
  }
  const Miles = num => {
    var divisor = 1000
    var cientos = Math.floor(num / divisor)
    var resto = num - cientos * divisor

    var strMiles = Seccion(num, divisor, 'UN MIL', 'MIL')
    var strCentenas = Centenas(resto)

    if (strMiles === '') return strCentenas
    return strMiles + ' ' + strCentenas
  }
  const Millones = num => {
    var divisor = 1000000
    var cientos = Math.floor(num / divisor)
    var resto = num - cientos * divisor

    var strMillones = Seccion(num, divisor, 'UN MILLON', 'MILLONES')
    var strMiles = Miles(resto)

    if (strMillones === '') return strMiles
    return strMillones + ' ' + strMiles
  }
  const NumeroALetras = num => {
    num = parseFloat(num)
    var data = {
      numero: num,
      enteros: Math.floor(num),
      centavos: Math.round(num * 100) - Math.floor(num) * 100,
      letrasCentavos: '',
      letrasMonedaPlural: '',
      letrasMonedaSingular: '',
    }
    if (data.centavos > 0) {
      data.letrasCentavos = ' CON ' + data.centavos + '/100'
    } else {
      data.letrasCentavos = ' CON  00/100'
    }

    if (data.enteros === 0)
      return 'CERO ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos
    if (data.enteros === 1)
      return (
        Millones(data.enteros) +
        ' ' +
        data.letrasMonedaSingular +
        ' ' +
        data.letrasCentavos
      )
    else
      return (
        Millones(data.enteros) +
        ' ' +
        data.letrasMonedaPlural +
        ' ' +
        data.letrasCentavos
      )
  }
  return NumeroALetras(value)
}
